import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=f79c6344&scoped=true"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=f79c6344&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79c6344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f79c6344')) {
      api.createRecord('f79c6344', component.options)
    } else {
      api.reload('f79c6344', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=f79c6344&scoped=true", function () {
      api.rerender('f79c6344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/privacy.vue"
export default component.exports